export const ROLES_LIST = {
    "admin": "5150",
    "subAdmin": "1984",
    "client": "1899"
}